export let juegoSelected=(valor)=>{ return {type:"JUEGO_SELECTED",payload:valor} };
export let estadoJuego=(valor)=>{ return {type:"ESTADO_JUEGO",payload:valor} };
export let newJuego=(valor)=>{ return {type:"NEW_JUEGO",payload:valor} };
export let juegosRedux=(valor)=>{ return {type:"JUEGOS",payload:valor} };